import React, { useState, useEffect } from "react";
import ProductCard from "../components/common/ProductCard";
import { useNavigate } from 'react-router-dom';
import Background from "../components/assets/images/shop-background.jpg";
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const Shop = ({ limitItems, isHomeScreen }) => {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const records = await pb.collection('Products').getFullList({
                    sort: 'created',
                });
                setProducts(records);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
        console.log('products:', products);
    }, [products]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categories = await pb.collection('Categories').getFullList({
                    sort: 'created',
                });
                setCategories(categories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);


    const filteredProducts = selectedCategory
        ? products.filter(product =>
            Array.isArray(product.categories) && product.categories.includes(selectedCategory)
        )
        : products;

    useEffect(() => {
        console.log("Selected Category:", selectedCategory);
        console.log("Filtered Products:", filteredProducts);
    }, [selectedCategory, filteredProducts]);

    const itemsToShow = isHomeScreen
        ? filteredProducts.slice(0, 2)
        : (limitItems ? filteredProducts.slice(0, limitItems) : filteredProducts);

    return (
        <div style={{ backgroundImage: `url(${Background})` }} className="bg-cover">
            <div className="container mx-auto px-4 py-12">
                <div className="flex flex-col items-center justify-center space-y-4">
                    <div className="relative">
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-500"></div>
                        <h1 className="font-bold text-4xl text-transparent bg-clip-text bg-gradient-to-r from-blue-700 to-purple-500 mb-2 text-center pb-2">
                            PRODUCTS & SERVICES
                        </h1>
                    </div>
                    <div className="w-full max-w-xs">
                        <select
                            value={selectedCategory}
                            onChange={(e) => setSelectedCategory(e.target.value)}
                            className="block w-full p-2 border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition ease-in-out"
                        >
                            <option value="">All Categories</option>
                            {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                    {cat.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="mt-8 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-6">
                    {itemsToShow.map((product, index) => (
                        <ProductCard key={index} product={product} />
                    ))}
                </div>
                {isHomeScreen && (
                    <div className='flex justify-center mt-8 pb-5'>
                        <button
                            className='bg-transparent text-blue-500 font-semibold py-2 px-6 border border-blue-500 rounded-md hover:bg-blue-500 hover:text-white transition-colors duration-300'
                            onClick={() => navigate('/shop')}>
                            Show More
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Shop;
